import { ReactNode } from "react";

import { Skeleton } from "~/screens/Scheduling/InitialVisit/components/SkeletonElements";
import { TimeZoneSelect } from "~/screens/Scheduling/InitialVisit/components/TimeZoneSelect";
import { useGetAppointmentDuration } from "~/screens/Scheduling/InitialVisit/hooks/use-get-appointment-duration";
import { VISIT_TYPES, VisitType } from "~/services";
import { useIsPatientRole, useSchedulingTimezoneStore } from "~/stores";
import { icons } from "~/ui";

type DurationDisplayProps = {
  visitType: VisitType;
  icon?: ReactNode;
};

export const DurationDisplay = ({
  visitType,
  icon = <icons.outline.ClockIcon className="size-5 text-gray-600" />,
}: DurationDisplayProps) => {
  const { duration, isLoading } = useGetAppointmentDuration(visitType);
  const { selectedTimeZone, setSelectedTimeZone } =
    useSchedulingTimezoneStore();
  const isPatient = useIsPatientRole();

  const showTimezone = visitType === VISIT_TYPES.INITIAL && isPatient;

  if (isLoading) {
    return <Skeleton className="h-6 w-16" />;
  }

  return (
    <div className="flex flex-1 flex-wrap items-center justify-between gap-1 md:justify-normal">
      <span
        className={
          showTimezone
            ? "flex items-center gap-2 border-gray-300 pr-2 md:border-r"
            : "flex items-center gap-2"
        }
      >
        {icon}
        <span className="text-neutral-900">{duration} min</span>
      </span>
      {showTimezone && (
        <TimeZoneSelect
          selectedTimeZone={selectedTimeZone}
          onTimeZoneChange={setSelectedTimeZone}
        />
      )}
    </div>
  );
};
